import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';
import { Wrapper } from './styles';

const Item = styled.span`
  display: inline-block;
  margin: ${({ theme }) => `0 ${theme.spacing.spacing40} 0 0`};
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  background: ${({ theme }) => theme.colors.surface20};
  width: 90px;
  height: 120px;
`;

function Placeholder() {
  return (
    <Wrapper>
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
    </Wrapper>
  );
}

export default memo(Placeholder);
